'use strict';

$.spinner().start();
window.ymkAsyncInit = function () {
    var e = document.getElementById('threshold');
    var countrycheck = $('#threshold').attr('data-country').toLowerCase();
    document.getElementById('btn-shadeFinderStart').style.display = 'none';

    var initParameters = {
        shadeFinderVersion: 'v4',
        disable2ColorComparison: true,
        hideAllButtonsOnResult: true,
        shadeFinderDeltaEThreshold: e.value,
        shadeFinderResultVersion: 'v2',
        skinSmoothStrength: 33,
        language: countrycheck,
        showShadeFinderLogo: false,
        userConsent: 'agree'
    };

    // Device type tablets Ipad Pro Ipad mini
    var windowSize = $(window).width();

    if (windowSize >= 500) {
        initParameters.width = 500;
        initParameters.height = 619;
    }

    // Init SF module
    window.YMK.init(initParameters);

    $.spinner().stop();
    if ($("#optin-vto-shadefiner").length) {
        $("#optin-vto-shadefiner").modal("show");

        $(".button-optin-submit").on("click", function() {
            $("#optin-vto-shadefiner").modal("hide");
            window.YMK.openShadeFinder();
        })
    } else {
        window.YMK.openShadeFinder();
    }

    window.YMK.addEventListener('backToLive', function () {
        $('.custom-shade-search').show();
    });

    window.YMK.addEventListener('enterTakePhoto', function () {
        $('.custom-shade-search').hide();
    }); 
    
    window.YMK.addEventListener('shadeFinderComplete', function (r) {
        $('#dev_tools2').text('').text('shade-found:' + JSON.stringify(r));
        var jsonshadevalue = $('#dev_tools').html();
        var parseJsonData = JSON.parse(jsonshadevalue);
        var idvalue = r.recommendations;
        var shadeId = [];
        var colorvalue = [];
        var shadevalue = [];
        var shadeSephoraUrls = [];
        var shadeProductUrls = [];
        if (!parseJsonData) {
            console.log('JSON file with products is missing.');
            return;
        }else {
            Object.keys(parseJsonData).map( function (idVariant) {
                for (let index = 0; index < idvalue.length; index++) {
                    if (idVariant == idvalue[index].matched.skuId) {
                        shadeId.push(idVariant);
                        colorvalue.push(parseJsonData[idVariant].colorCode);
                        shadevalue.push(parseJsonData[idVariant].shadeName);
                        if (parseJsonData[idVariant].urlSephora) {
                            shadeSephoraUrls.push(parseJsonData[idVariant].urlSephora);
                        }
                        if (parseJsonData[idVariant].urlSite) {
                            shadeProductUrls.push(parseJsonData[idVariant].urlSite);
                        }
                    }
                }
            })
        }
        window.YMK.enableCompare();

        $('#IDshadenumber').html(shadeId);
        $('.skintone-subtitle-index').empty().html('hex ' + colorvalue[0]);
        $('.skintone-subtitle-pfcolor-prop').empty().html(shadevalue[0]);
        $('#threshold').val(shadeId[0]);

        var nbShade = 3;
        // Hide shade if necessary
        if(!shadeId[1]) {
            $('.skintone-circle-1').hide();
            nbShade--;
        }

        if (!shadeId[2]) {
            $('.skintone-circle-3').hide();
            nbShade--;
        }

        var $skintoneClick1 = $('.skintone-click1'),
            $skintoneClick2 = $('.skintone-click2'),
            $skintoneClick3 = $('.skintone-click3');
            

        $skintoneClick1.attr('data-value', shadeId[1]);
        $skintoneClick2.attr('data-value', shadeId[0]);
        $skintoneClick3.attr('data-value', shadeId[2]);

        if (shadeSephoraUrls.length) {
            $skintoneClick1.attr('data-url-sephora', shadeSephoraUrls[1]);
            $skintoneClick2.attr('data-url-sephora', shadeSephoraUrls[0]);
            $skintoneClick3.attr('data-url-sephora', shadeSephoraUrls[2]);
        } else if (shadeProductUrls.length) {
            $skintoneClick1.attr('data-url-product', shadeProductUrls[1]);
            $skintoneClick2.attr('data-url-product', shadeProductUrls[0]);
            $skintoneClick3.attr('data-url-product', shadeProductUrls[2]);
        }

        $('.skintone-shadename1').text(shadevalue[1]);
        $('.skintone-shadename2').text(shadevalue[0]);
        $('.skintone-shadename3').text(shadevalue[2]);

        $('.skintone-wrapper').show();
        $('.matching-wrapper').show();
        $('.square1 circle').attr('fill', colorvalue[1]);
        $('.square2 circle').attr('fill', colorvalue[0]);
        $('.square3 circle').attr('fill', colorvalue[2]);
        $('.skintone-click2').trigger('click', [shadeId, colorvalue]).addClass('click-first-button');

        var dataUrl = $(".gtmurl").attr("data-url");
        dataUrl = dataUrl + '?products=' + shadeId.slice(0, nbShade);
            
        $.ajax({
            url: dataUrl,
            type: 'get',
            dataType: 'json',
            success: function (data) {
                dataLayer.push(data.productListGtm);
                if (data.productListGtm.ecommerce.impressions[0]) {
                    var productName = data.productListGtm.ecommerce.impressions[0].name;
                    var vtoSite = $(".gtmsite").attr("data-site");

                    dataLayer.push({
                        'event': 'shade_finder_result',
                        'sf_product_name': productName,
                        'sf_site_name': vtoSite,
                    });
                }
            },
            error: function () {     
            }
        });
            
        var dataUrl2 = $("#dev_tools_updated").attr("data-url");
        dataUrl2 = dataUrl2
            + '?products=['
            + shadeId[0]
            + ','
            + shadeId[1]
            + ','
            + shadeId[2]
            + ']';
            
        $.ajax({
            url: dataUrl2,
            type: 'get',
            dataType: 'json',
            success: function (data) {
                $('.skintone-click1').attr('aria-label', data.ressources + " " + shadevalue[1] + " " + data.productslist[1].variant);
                $('.skintone-click2').attr('aria-label', data.ressources + " " + shadevalue[0] + " " + data.productslist[0].variant);
                $('.skintone-click3').attr('aria-label', data.ressources + " " + shadevalue[2] + " " + data.productslist[2].variant);
            },
            error: function (err) {
                console.log('dataUrl2 err', err);
            }
        });   
    });
}